import React , {Component} from 'react';
import './sectionliberaryviewpage.styles.css';
import books from '../datasetwithsections';

import CardList from '../../components/section.card-list/card-list.component';

class SectionLiberaryViewPage extends Component{

  constructor(props){
    super();

    this.state = {
      books:books[props.match.params.blink],
      
    };
  }

  render(){
    const { books } = this.state;
    
    return(
      <div >
        <h1>مكتبة الكتب</h1>
        < CardList books={books} />
      </div>
    );
  }
}

export default SectionLiberaryViewPage;
